import { DateTimeUtility } from 'src/shared/utility/date-time.utility';

export interface UserSummaryJSON {
	id: number;
	netId: string;
	employeeId: string;
	firstName: string;
	lastName: string;
	dateOfBirth: string;
	lastValidated: string;
	lastUpdated: string;
	archived: boolean;
}

export class UserSummary {
	constructor(
		public id: number,
		public netId: string,
		public employeeId: string,
		public firstName: string,
		public lastName: string,
		public dateOfBirth: Date,
		public lastValidated: Date,
		public lastUpdated: Date,
		public archived: boolean
	) {}

	static fromJSON(json: UserSummaryJSON): UserSummary {
		const user = Object.create(UserSummary.prototype);
		return Object.assign(user, json, {
			dateOfBirth: json.dateOfBirth
				? DateTimeUtility.fromDatabaseDate(json.dateOfBirth)
				: null,
			lastValidated: json.lastValidated
				? DateTimeUtility.fromDatabaseDate(json.lastValidated)
				: null,
			lastUpdated: json.lastUpdated
				? DateTimeUtility.fromDatabaseDatetime(json.lastUpdated)
				: null,
		});
	}
}
